module.exports = __webpack_public_path__ + "img/logo_27.7735e87b.png";